import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createSidebarSlice, SidebarSlice } from "./sideBar.slice";

export type SkyViewStore = SidebarSlice;

export const useSkyViewStore = create<SkyViewStore>()(
  persist(
    immer((...a) => ({
      ...createSidebarSlice(...a),
    })),
    {
      name: "sky-view-storage",
      partialize: (state) => ({ isExpanded: state.isExpanded }),
    }
  )
);
